var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cta text-center"},[_c('div',[_c('h2',[_vm._v(" Ideeën opdoen? ")]),_c('router-link',{staticClass:"button",attrs:{"to":{ name: 'Inspiration', params: {} }}},[_vm._v(" Laat je inspireren ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }